/**
 * colorSchemeMap — FE-side resolver from SDK `colorScheme` semantic tokens to
 * Tailwind background classes used on the picker icon container.
 *
 * v1 mapping (per TDD §7.3 — preserves the current FE iconBg colors verbatim):
 *   - 'blue'   → 'bg-[#EFF6FF]' (Enrollment)
 *   - 'green'  → 'bg-[#F0FDF4]' (Financial)
 *   - 'orange' → 'bg-[#FFF7ED]' (Bunks)
 *   - 'violet' → 'bg-[#FAF5FF]' (Staff)
 *   - 'amber'  → 'bg-[#FEF3C7]' (future use)
 *   - 'rose'   → 'bg-[#FFF1F2]' (future use)
 *
 * Fallback (unknown token or undefined): 'blue' bg ('bg-[#EFF6FF]').
 */

const FALLBACK_BG = 'bg-[#EFF6FF]'

export const COLOR_SCHEME_MAP: Record<string, string> = {
  blue: 'bg-[#EFF6FF]',
  green: 'bg-[#F0FDF4]',
  orange: 'bg-[#FFF7ED]',
  violet: 'bg-[#FAF5FF]',
  amber: 'bg-[#FEF3C7]',
  rose: 'bg-[#FFF1F2]',
}

export function resolveColorSchemeClass(colorScheme?: string): string {
  if (!colorScheme) return FALLBACK_BG
  return COLOR_SCHEME_MAP[colorScheme] ?? FALLBACK_BG
}
